import createReducer from "./createReducer";

import { SUPPRESS_ALL_GROWL, SUPPRESS_SUCCESS_GROWL } from "utils/constants";


export const EXPORT_ACTIONS = {
	EXPORT_VERSIONS_AJAX:"EXPORT_VERSIONS_AJAX",
	EXPORT_VERSIONS_SUCCESS:"EXPORT_VERSIONS_SUCCESS",
	EXPORT_VERSIONS_ERROR:"EXPORT_VERSIONS_ERROR",

	VALUE_LIST_MATCH_AJAX: "VALUE_LIST_MATCH_AJAX",
	VALUE_LIST_MATCH_SUCCESS: "VALUE_LIST_MATCH_SUCCESS",
	VALUE_LIST_MATCH_ERROR: "VALUE_LIST_MATCH_ERROR",
};

export function exportVersions(oneTab = true, ...ids){
	return (dispatch) => {
		return dispatch({
			type:EXPORT_ACTIONS.EXPORT_VERSIONS_AJAX,
			AJAX:{
				url:"version/export_temp",
				method:"post",
				data:{
					oneTab,
					creativeIdList:ids,
				},
				success:EXPORT_ACTIONS.EXPORT_VERSIONS_SUCCESS,
				error:EXPORT_ACTIONS.EXPORT_VERSIONS_ERROR,
			},
			meta:{
				...SUPPRESS_SUCCESS_GROWL,
				tracking:{
					eventAction:"Grid Action",
					eventCategory:"Export Versions",
					eventLabel:"Export",
					type:"action",
				},
			},
		});
	};
}

/**
 * Before making an API call to export versions, we first must check if
 * the creatives have variable keys that do not match. A mismatch results
 * in multiple tabs being generated in the spreadsheet when exporting. HOPI-1018
 */
export function valueListMatch(...ids) {
	return (dispatch) => {
		return dispatch({
			type: EXPORT_ACTIONS.VALUE_LIST_MATCH_AJAX,
			AJAX:{
				url:"version/valuelistmatch",
				method:"post",
				data:{
					creativeIdList: ids,
				},
				success:EXPORT_ACTIONS.VALUE_LIST_MATCH_SUCCESS,
				error:EXPORT_ACTIONS.VALUE_LIST_MATCH_ERROR,
			},
			meta: SUPPRESS_ALL_GROWL,
		});
	};
}

const initialState = {};
const handlers = {
	// [EXPORT_ACTIONS.EXPORT_VERSIONS_AJAX]:
};


export default createReducer(initialState, handlers);
